import { IconButton, Rating } from "@mui/material";
import { FileCopyOutlined } from "@mui/icons-material";
import styled from "styled-components";
import { Stack } from "@mui/system";

export const StyledKBDetailHeader = styled.div(
  ({ theme }) => `
    padding-bottom: 0;
    margin-top: ${theme.uptimeSpace[4]}px;
    &.kb-detail {
      font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
      color: ${theme.uptimeColors.textColors.primary};
      line-height: 1.42857;
      width: 100%;
    }
    .MuiTypography-root {
      .MuiIconButton-root {
        height: auto;
        display; flex;
        align-items: flex-start !important;
        transform: translateY(-10px);
      }
      button {
        padding: 0;
        background: 'transparent';
        svg {
          font-size: ${theme.uptimeFontSizes.desktop.fz4}px !important;
          color: ${theme.uptimeColors.generalColors.icon.enabled} !important;
        }
      }
    }
    .kb-header {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .kb-type {
        font-size: ${theme.uptimeFontSizes.desktop.fz1}px;
        text-transform: uppercase;
        color: ${theme.uptimeColors.grayScales.darkGray};
        margin: 0 0 ${theme.uptimeSpace[4]}px 0;
        font-weight: 700;
        &::after {
          content: ">";
          margin: 0 ${theme.uptimeSpace[5]}px;
        }
      }
      .kb-number {
        font-size: ${theme.uptimeFontSizes.desktop.fz1}px;
        text-transform: uppercase;
        color: ${theme.uptimeColors.grayScales.darkGray};
        margin: 0 0 ${theme.uptimeSpace[4]}px 0;
        font-weight: 700;
        &::after {
          content: "";
        }
      }
    }
    .title {
      display: flex;
      .MuiTypography-root {
        font-family: ${theme.uptimeFonts.primary};
        font-size: 32px !important;
        @media (min-width: ${theme.breakpoints.sm}) {
          font-size: 40px !important;
        }
      }
    }
    .MuiRating-root {
      color: ${theme.uptimeColors.newsKnowledgeColors.rating};
      font-size: ${theme.uptimeSpace[7]}px;
    }
    .inner {
      display: flex;
      align-items: center;
      margin-top: ${theme.uptimeSpace[13]}px;
    }
    .control {
      display: flex;
      align-items: center;
      .MuiTypography-root {
        font-size: 12px !important;
        @media (min-width: ${theme.breakpoints.sm}) {
          font-size: 14px;
        }
      }
    }
    .views {
      margin: 0 0 0 ${theme.uptimeSpace[10]}px;
    }
    .kb-useful-percentage {
      display: flex;
      align-items: center;
      svg {
        margin-right: ${theme.uptimeSpace[2] + 1}px;
      }
      .kb-text {
        display: none;
        @media (min-width: ${theme.breakpoints.sm}) {
          display: flex;
        }
      }
    }
    .kb-category{
      background-color: ${theme.uptimeColors.grayScales.grayish};
      padding: ${theme.uptimeSpace[2]}px ${theme.uptimeSpace[4]}px;
      margin: ${theme.uptimeSpace[7]}px 0 48px 0;
      border-radius: 16px;
      width: fit-content;
      span {
        font-style: normal;
        font-weight: 600;
        font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
        text-transform: uppercase;
        line-height: ${theme.uptimeLineHeights.desktop.lh3}px;
      }
    }
`
);

export const StyledRating = styled(Rating)`
  ${({ theme }) => `
    padding: 0 ${theme.uptimeSpace[6]}px;
    margin: 0 ${theme.uptimeSpace[5]}px;
    border-left: 1px solid ${theme.uptimeColors.grayScales.darkGray};
    border-right: 1px solid ${theme.uptimeColors.grayScales.darkGray};
    font-size: ${theme.uptimeFontSizes.desktop.fz5}px;
    .MuiRating-icon {
      svg{
        width: ${theme.uptimeSpace[9]}px;
        height: ${theme.uptimeSpace[9]}px;
        @media (min-width: ${theme.breakpoints.sm}) {
          width: ${theme.uptimeSpace[12]}px;
          height: ${theme.uptimeSpace[12]}px;
        }
      }
    }
  `}
`;
export const StyledUseFul = styled(Stack)<{ isMobile?: boolean }>`
  ${({ theme, isMobile }) => `
    padding: 0 ${theme.uptimeSpace[6]}px;
    margin: 0 ${theme.uptimeSpace[5]}px;
    border-left: ${isMobile ? 'unset' : `1px solid ${theme.uptimeColors.grayScales.darkGray}`};
    font-size: ${theme.uptimeFontSizes.desktop.fz5}px;
    .MuiRating-icon {
      svg{
        width: ${theme.uptimeSpace[9]}px;
        height: ${theme.uptimeSpace[9]}px;
        @media (min-width: ${theme.breakpoints.sm}) {
          width: ${theme.uptimeSpace[12]}px;
          height: ${theme.uptimeSpace[12]}px;
        }
      }
    }
  `}
`;

export const StyledHowToTranslate = styled(Stack)`
  ${({ theme }) => `
    align-items: center;
    margin-left: ${theme.uptimeSpace[5]}px;
    padding: 0 ${theme.uptimeSpace[6]}px;
    border-left: 1px solid ${theme.uptimeColors.grayScales.darkGray};
    .MuiButtonBase-root {
      min-height: unset;
      padding: 0 ${theme.uptimeSpace[5]}px;
    }
  `}
`;

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  padding: 0,
  background: "transparent",
  "@media print": {
    display: "none !important",
  },
}));

export const StyledFileCopyOutline = styled(FileCopyOutlined)(({ theme }) => ({
  fontSize: `${theme.uptimeFontSizes.desktop.fz4}px`,
  color: `${theme.uptimeColors.generalColors.button.outline.enabled}`,
}));
